import { Box, Rating, Typography } from "@mui/material";
import { Star } from "@mui/icons-material";

interface RatingStarsProps {
  value: number;
  showValue?: boolean;
  size?: "small" | "medium" | "large";
}

export default function RatingStars({
  value,
  showValue = true,
  size = "small",
}: RatingStarsProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      <Rating
        value={value}
        precision={0.1}
        readOnly
        size={size}
        icon={<Star fontSize="inherit" />}
        emptyIcon={<Star fontSize="inherit" />}
        sx={{ color: "primary.main" }}
      />
      {showValue && (
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
          }}
        >
          {value.toFixed(1)}
        </Typography>
      )}
    </Box>
  );
}
